import cn from "classnames";
import type { GeoChartColumn } from "../../types";

export const GeoChartHeaderColumn = ({
	column,
}: {
	column: GeoChartColumn;
}) => {
	return (
		<div
			style={{
				width: column.width,
			}}
			className={cn("flex items-center justify-center border-r", {
				"flex-grow": !column.width,
			})}
		>
			<div
				className="rotate-180 text-sm"
				style={{ writingMode: "vertical-rl" }}
			>
				{column.name}
			</div>
		</div>
	);
};
